import { render, staticRenderFns } from "./SearchAgent.vue?vue&type=template&id=6f081008&scoped=true"
import script from "./SearchAgent.vue?vue&type=script&lang=js"
export * from "./SearchAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f081008",
  null
  
)

export default component.exports